var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShisha(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_45187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5764 31.0625H19.4247C20.8374 30.0143 21.753 28.3342 21.753 26.44C21.753 23.263 19.1775 20.6875 16.0005 20.6875C12.8235 20.6875 10.248 23.263 10.248 26.44C10.248 28.3342 11.1637 30.0143 12.5764 31.0625Z",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3438 20.6875H10.6562V17H21.3438V20.6875Z",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6985 14.3021C18.6985 15.7921 17.4906 17 16.0006 17C14.5106 17 13.3027 15.7921 13.3027 14.3021C13.3027 12.8121 14.5106 11.6041 16.0006 11.6041C17.4906 11.6041 18.6985 12.8121 18.6985 14.3021Z",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.00006V11.6042",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9265 5H14.0723L13.3848 0.9375H18.614L17.9265 5Z",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 5H20.4375",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2471 26.4399C6.80017 26.4399 4.00586 23.6456 4.00586 20.1987V19.7413C4.00586 16.2943 6.80017 13.4999 10.2471 13.4999H13.5901",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6973 13.5H22.6963C24.0229 13.5 25.0983 12.4246 25.0983 11.098V10",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688 10H23.3125V7.45313C23.3125 6.4435 24.131 5.625 25.1406 5.625C26.1502 5.625 26.9688 6.4435 26.9688 7.45313V10Z",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1406 5V2.96875",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3887 31.437C32.7755 31.1081 43.7284 22.342 43.7284 22.342L41.867 13.6941C41.6178 12.5361 41.7704 11.3278 42.2997 10.2681L46.9677 1.65007C47.1574 1.2172 47.5852 0.937511 48.0577 0.937511C48.715 0.937511 49.2477 1.47026 49.2477 2.12751V21.855C49.2477 22.7046 48.9477 23.5269 48.4005 24.1768L43.1978 30.3511",
    stroke: "#222222",
    strokeWidth: 1.875,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_45187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShisha);
export default __webpack_public_path__ + "static/media/shisha.8d23cff22af27fd5c6948db2e5149651.svg";
export { ForwardRef as ReactComponent };